// GENERATED by scripts/build-icons.mjs from icons/box.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Box = createIcon('box', [
  ['path', { d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" }],
  ['path', { d: "m3.3 7 8.7 5 8.7-5" }],
  ['path', { d: "M12 22V12" }],
])
